import Api from 'api'
import React from 'react';
import Button from './Button';
import { Payment } from 'components';
import Cookies from 'universal-cookie';
import { FaMoneyCheck } from 'react-icons/fa';
export default class _payment extends React.Component {

  constructor(props) {
    super(props);
    this.api = new Api();
    this.cookies = new Cookies();
    this.state = { loading : false }
  }

  complete_order = async () => {

    if (this.state.loading) return;

    this.loading(true);

    const { values, total } = this.props;

    const { charge } = values.delivery_method;

    const session = this.cookies.get('session_data');

    const payload = this.payload(values,total,charge);

    console.log('payload :', payload);

    const checkout_ref = await this.api.checkout(payload);

    const session_data = { ...session, checkout: checkout_ref };

    this.cookies.set('session_data',{...session_data},{path:'/'});

    await Payment({...payload,ref:checkout_ref,cid:session.cid}, this.open_ipay);

  }

  loading = (value) => {

    const { loading } = this.props.values;

    if (value!==loading) return this.props.onSubmit('loading', value);

  }

  payload = (values,total,charge) => {

    const omit = ['step','loading','errors','delivery','']

    const customer = Object.keys(values).reduce((object, key) => {

      if (!omit.includes(key)) object[key] = values[key];

      return object;

    }, {});

    const cart = this.props.cart.map(a => this.cart_item(a));

    return {...customer, cart, amount: total+charge };

  }

  cart_item = (item) => {

    const { images, handle, title, pricing, quantity } = item;

    return { handle, title, pricing, quantity, image: images[0] };

  }

  open_ipay = (url) => window.open(url,'_self');

  render() {
    return (
      <PaymentForm
        values={this.props.values}
        onCompleteOrder={this.complete_order}
        navigateBack={this.props.navigateBack}
      />
    )
  }
}


const PaymentForm = ({ values, navigateBack, onCompleteOrder, loading }) => {

  const {
    step,
    location,
    address_2,
    email_address,
    delivery_method
  } = values;

  const { caption, charge } = delivery_method;

  return (step===3) && (
    <div className='Payment-Information'>

      <div className="Previous-Data">

        <div className="Data-Row">
          <div className="label">Contact</div>
          <div className="value">{email_address}</div>
        </div>

        <div className="Data-Row">
          <div className="label">Address</div>
          <div className="value">
            {`${address_2}, ${location}`}
          </div>
        </div>

        <div className="Data-Row">
          <div className="label">Delivery</div>
          <div className="value">
            {`${caption} · ${charge} KES`}
          </div>
        </div>

      </div>

      <div className="Section-Title">
        Complete Payment
      </div>

      <div className="Section-Banner">
        <FaMoneyCheck className='icon'/>
        <div className="caption">
        By pressing Complete order it means you have confirmed your order & are ready to pre-pay. You will be redirected to a secure and encrypted gateway (ipay). Ensure you have enough money on your Credit/Debit card or Mpesa/EazzyPay
        </div>
      </div>

      <Button
        loading={loading}
        label='Complete Order'
        backButtonLabel='Return to Shipping'
        onClickEvent={() => onCompleteOrder()}
        onClickBackButton={() => navigateBack(false)}
      />

    </div>
  )
}
